/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dimmer, Divider, Grid, Icon, Loader } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import Table from 'semantic-table-grid';

import { ViewBtn } from 'components/Buttons';
import Modal from 'components/Modal';

import currencyFormatter from 'shared/lib/currencyFormatter';
import AllegatoService from 'shared/services/api/allegato';
import GestionePratica from 'shared/services/rpc/gestione-pratica';
// Services
import aclService from '../../../shared/lib/acl';

const defaultCurrentElement = {
  accessorio: '',
  cfIntestatari: '',
  collaboratorel3: '',
  createdAt: '',
  dataDelibera: '',
  dataErogazione: '',
  dataIncassoPremio: '',
  dataPresentazione: '',
  dataStipula: '',
  durata: '',
  erogato: '',
  finalita: '',
  finanziato: '',
  forzata: '',
  franchigia: '',
  importoTotaleProvvigioni: '',
  intestatari: '',
  liquidato: '',
  ltv: '',
  montante: '',
  payinLordo: '',
  percProvvigione: '',
  pratica: '',
  premioLordoPolizza: '',
  premioNettoPolizza: '',
  prodotto: '',
  provvigione: '',
  provvigioniAggiuntive: '',
  ricorrenza: '',
  seriale: '',
  speseIstruttoria: '',
  spread: '',
  importazione: {
    seriale: '',
  },
  meseCompetenza: '',
  annoCompetenza: '',
};

export class ProvvigioniImpresa extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      flussi: [],
      currentElement: defaultCurrentElement,
      detailModal: false,
      open: false,
      loadingFattura: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  onView = (data) => this.setState({ currentElement: data.praticaImportata, detailModal: true });

  getDivider = (str) => (
    <Grid.Column
      style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}
      width={16}
      key="tipologia-anagrafica"
    >
      <Divider horizontal>{str}</Divider>
    </Grid.Column>
  );

  getUppercase = (str) => (str ? str.toUpperCase() : '');

  getDate = (date) => (date ? moment.unix(date).format('DD/MM/YYYY') : '--');

  closeDetailModal = () => this.setState({ detailModal: false, currentElement: _.cloneDeep(defaultCurrentElement) });

  openModal = () => this.setState({ open: true });
  closeModal = () => this.setState({ open: false });

  download = (id) => {
    this.setState({ loadingFattura: id });
    AllegatoService.downloadFatturaProvvigione(id)
      .then((res) => {
        const disposition = res.headers['content-disposition'];
        const type = res.headers['content-type'];
        const filename = decodeURI(disposition.match(/filename=(.*)/)[1]);
        this.showFile(res.data, type, filename);
        this.setState({ loadingFattura: null });
      })
      .catch(() => {
        this.setState({ loadingFattura: null });
      });
  };

  showFile = (blob, type) => {
    const file = new Blob([blob], { type });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  loadData = () => {
    this.setState({ loading: true });

    GestionePratica.getDatiCommissioningImpresa(this.props.processoImpreseId)
      .then((res) => this.setState({ flussi: res.flussi }))
      .finally(() => this.setState({ loading: false }));
  };

  columns = [
    {
      key: 'nominativo',
      name: 'Nominativo',
      formatter: ({ value }) => (value !== 'kiron' ? this.getUppercase(value) : <b>{this.getUppercase(value)}</b>),
    },
    {
      key: 'profilo',
      name: 'Profilo',
      formatter: null,
    },
    {
      key: 'importo',
      name: 'Importo',
      formatter: ({ value }) => currencyFormatter.format(value),
    },
    {
      key: 'fatturaId',
      name: 'Fattura',
      formatter: ({ value }) => (
        <div style={{ textAlign: 'center' }}>
          {(value &&
            ((this.state.loadingFattura === value && <Icon loading name="spinner" />) || (
              <Icon name="download" onClick={() => this.download(value)} />
            ))) || <Icon name="ellipsis horizontal" color="yellow" />}
        </div>
      ),
    },
    {
      key: 'id',
      name: 'Azioni',
      formatter: ({ data }) => (
        <div style={{ textAlign: 'center', visibility: data.praticaImportata ? 'visible' : 'hidden' }}>
          <ViewBtn key="dettagli" action={() => data.praticaImportata && this.onView(data)} />
        </div>
      ),
    },
  ];

  payOutElement = (importoTotaleProvvigioni) => {
    if (!aclService.check(this.props.userAcl, ['collaboratore', 'senior'])) {
      return (
        <div>
          <b>Pay out:</b> {importoTotaleProvvigioni ? currencyFormatter.format(importoTotaleProvvigioni) : '--'}
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const {
      accessorio,
      cfIntestatari,
      collaboratorel3,
      createdAt,
      dataDelibera,
      dataErogazione,
      dataIncassoPremio,
      dataPresentazione,
      dataStipula,
      durata,
      erogato,
      finalita,
      finanziato,
      forzata,
      franchigia,
      importoTotaleProvvigioni,
      intestatari,
      liquidato,
      ltv,
      montante,
      payinLordo,
      percProvvigione,
      pratica,
      premioLordoPolizza,
      premioNettoPolizza,
      prodotto,
      provvigioniAggiuntive,
      ricorrenza,
      speseIstruttoria,
      spread,
      compagnia,
      meseCompetenza,
      annoCompetenza,
      tipoProvvigione,
    } = this.state.currentElement;

    return (
      <div style={{ marginBottom: 14 }}>
        <Modal
          onClose={this.closeDetailModal}
          title={`Dati commissioning pratica ${this.state.currentElement ? this.state.currentElement.pratica : ''}`}
          size="large"
          open={this.state.detailModal}
        >
          {_.get(this.state.currentElement, 'id') && (
            <Grid>
              <Grid.Column width={4}>
                <div>
                  <b>Pratica:</b> {pratica || '--'}
                </div>
                <div>
                  <b>Collaboratore:</b> {collaboratorel3 || '--'}
                </div>
                <div>
                  <b>Intestatario:</b> {intestatari || '--'}
                </div>
                <div>
                  <b>Codice fiscale:</b> {cfIntestatari || '--'}
                </div>
                <div>
                  <b>% Provvigione:</b> {percProvvigione || '--'}
                </div>
                <div>
                  <b>Pay in lordo:</b> {payinLordo ? currencyFormatter.format(payinLordo) : '--'}
                </div>
                {this.payOutElement(importoTotaleProvvigioni)}
                <div>
                  <b>Provvigioni aggiuntive:</b>{' '}
                  {provvigioniAggiuntive ? currencyFormatter.format(provvigioniAggiuntive) : '--'}
                </div>
                <div>
                  <b>Prodotto:</b> {prodotto || '--'}
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div>
                  <b>Durata:</b> {durata || '--'}
                </div>
                <div>
                  <b>Finalità:</b> {finalita || '--'}
                </div>
                <div>
                  <b>LTV:</b> {ltv || '--'}
                </div>
                <div>
                  <b>Spese istruttoria:</b> {speseIstruttoria ? currencyFormatter.format(speseIstruttoria) : '--'}
                </div>
                <div>
                  <b>Franchigia:</b> {franchigia ? currencyFormatter.format(franchigia) : '--'}
                </div>
                <div>
                  <b>Spread:</b> {spread || '--'}
                </div>
                <div>
                  <b>Seriale:</b> {_.get(this.state.currentElement, 'importazione.seriale') || '--'}
                </div>
                <div>
                  <b>Premio lordo:</b> {premioLordoPolizza ? currencyFormatter.format(premioLordoPolizza) : '--'}
                </div>
                <div>
                  <b>Premio netto:</b> {premioNettoPolizza ? currencyFormatter.format(premioNettoPolizza) : '--'}
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div>
                  <b>Ricorrenza:</b> {ricorrenza || '--'}
                </div>
                <div>
                  <b>Erogato:</b> {erogato ? currencyFormatter.format(erogato) : '--'}
                </div>
                <div>
                  <b>Liquidato:</b> {liquidato ? currencyFormatter.format(liquidato) : '--'}
                </div>
                <div>
                  <b>Montante:</b> {montante ? currencyFormatter.format(montante) : '--'}
                </div>
                <div>
                  <b>Finanziato:</b> {finanziato ? currencyFormatter.format(finanziato) : '--'}
                </div>
                <div>
                  <b>Compagnia:</b> {compagnia || '--'}
                </div>
                <div>
                  <b>Prodotto accessorio:</b> {accessorio ? 'Si' : 'No'}
                </div>
                <div>
                  <b>Data creazione:</b> {createdAt ? moment.unix(createdAt).format('DD/MM/YYYY') : '--'}
                </div>
                <div>
                  <b>Data presentazione:</b>{' '}
                  {dataPresentazione ? moment.unix(dataPresentazione).format('DD/MM/YYYY') : '--'}
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div>
                  <b>Data delibera:</b> {dataDelibera ? moment.unix(dataDelibera).format('DD/MM/YYYY') : '--'}
                </div>
                <div>
                  <b>Data stipula:</b> {dataStipula ? moment.unix(dataStipula).format('DD/MM/YYYY') : '--'}
                </div>
                <div>
                  <b>Data erogazione:</b> {dataErogazione ? moment.unix(dataErogazione).format('DD/MM/YYYY') : '--'}
                </div>
                <div>
                  <b>Data incasso premio:</b>{' '}
                  {dataIncassoPremio ? moment.unix(dataIncassoPremio).format('DD/MM/YYYY') : '--'}
                </div>
                <div>
                  <b>Forzata:</b> {forzata ? 'Si' : 'No'}
                </div>
                <div>
                  <b>Mese competenza:</b> {meseCompetenza || '--'}{' '}
                </div>
                <div>
                  <b>Anno competenza:</b> {annoCompetenza || '--'}{' '}
                </div>
                <div>
                  <b>Tipo provvigione:</b> {tipoProvvigione || '--'}{' '}
                </div>
              </Grid.Column>
            </Grid>
          )}
        </Modal>

        <Modal
          onClose={this.closeModal}
          title="Provvigioni di pratica"
          trigger={
            <Button fluid positive onClick={this.openModal}>
              PROVVIGIONI DI PRATICA
            </Button>
          }
          size="tiny"
          open={this.state.open}
        >
          <Dimmer.Dimmable as={Grid} dimmed={this.state.loading}>
            <Grid.Column width={16}>
              {this.state.flussi.length === 0 && (
                <div style={{ color: '#999', textAlign: 'center' }}>
                  <i> Nessuna provvigione presente </i>
                </div>
              )}
              {this.state.flussi.map((flusso) => (
                <div style={{ marginBottom: 22 }} key={flusso.flussoInfinityId}>
                  <div>
                    <b>Tipo provvigione: </b> {_.get(flusso, 'tipoProvvigione') || '--'}
                  </div>
                  <div>
                    <b>Numero riga: </b>
                    {_.get(flusso, 'flussoInfinityId')
                      ? _.get(flusso, 'flussoInfinityId') === 'DA_CREARE'
                        ? ''
                        : _.get(flusso, 'flussoInfinityId')
                      : '--'}
                  </div>
                  <Table key={flusso.flussoInfinityId} columns={this.columns} elements={flusso.provvigioni} />
                </div>
              ))}
            </Grid.Column>
            <Dimmer active={this.state.loading} inverted>
              <Loader inverted />
            </Dimmer>
          </Dimmer.Dimmable>
        </Modal>
      </div>
    );
  }
}

ProvvigioniImpresa.propTypes = {
  processoImpreseId: PropTypes.string,
  userAcl: PropTypes.object,
};

export default ProvvigioniImpresa;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ProvvigioniImpresa/index.js